import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Menu } from "lucide-react";
import { useState } from "react";

export const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="border-b bg-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 justify-between items-center">
          <Link to="/" className="flex flex-shrink-0 items-center gap-2">
            <img 
              src="/lovable-uploads/30e09b3a-7f5e-4ff7-9a02-7dcfcd6951b6.png" 
              alt="Sibystock Logo" 
              className="h-8 w-8"
            />
            <span className="text-xl sm:text-2xl font-bold text-primary-800">Sibystock</span>
          </Link>
          
          {/* Mobile menu button */}
          <div className="flex md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-600 hover:text-gray-900"
            >
              <Menu className="h-6 w-6" />
            </button>
          </div>

          {/* Desktop navigation */}
          <div className="hidden md:flex items-center space-x-4">
            <Link to="/login-owner">
              <Button variant="ghost">Connexion</Button>
            </Link>
            <Link to="/register">
              <Button>Inscription</Button>
            </Link>
          </div>
        </div>

        {/* Mobile navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 space-y-2">
            <Link to="/login-owner" className="block">
              <Button variant="ghost" className="w-full justify-start">
                Connexion
              </Button>
            </Link>
            <Link to="/register" className="block">
              <Button className="w-full justify-start">
                Inscription
              </Button>
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};